import SessionStorageService from "@/services/SessionStorageService";
import { Configuration } from "@/apiGenerate/medserver";
import { Auth } from "@/models/auth.model";
import { httpFetch } from "../functions/httpInterceptor.js";

const token = SessionStorageService.getItem(Auth.TOKEN);

export const medServerApiConfig = new Configuration({
    basePath: process.env.VUE_APP_MEDSERVER_BASE_URL,
    fetchApi: httpFetch
});
